export default "__VITE_ASSET__BymhcBkN__"